<template>
  <v-flex
    id="possessions"
    class="question"
  >
    <p class="mb-0 text-uppercase">
      {{ getPossessionsQuestions.living_conditions.label }}
    </p>
    <h2 class="display-3 display-3_dark">
      {{ getPossessionsQuestions.label }}
    </h2>
    <ol class="questions-list">
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('living_conditions')"
        class="mt-4"
      >
        <div v-if="getPossessionsQuestions.living_conditions.hasOwnProperty('type')">
          <p
            class="header"
            :class="{ required: getPossessionsQuestions.living_conditions.type.required }"
          >
            {{ getPossessionsQuestions.living_conditions.type.label }}
          </p>
          <ConfirmButtons
            v-model="livingConditions.type"
            v-validate="{ required: getPossessionsQuestions.living_conditions.type.required }"
            :btn-left="livingConditionsTypeResource[0].description"
            :btn-right="livingConditionsTypeResource[1].description"
            possessions
            :error-messages="errors.collect('livingConditions.type')"
            :data-vv-as="$t('label.question')"
            :data-vv-name="'livingConditions.type'"
            :disabled="readOnly"
          />
        </div>
        <v-layout
          align-center
          justify-start
          class="mt-3"
          :wrap="$vuetify.breakpoint.smAndDown"
        >
          <v-layout
            v-if="getPossessionsQuestions.living_conditions.hasOwnProperty('roomsAmount')"
            align-center
            shrink
          >
            <span>{{ getPossessionsQuestions.living_conditions.roomsAmount.label }}</span>
            <CounterButtons
              v-model="livingConditions.roomsAmount"
              v-validate="{
                required: getPossessionsQuestions.living_conditions.roomsAmount.required
              }"
              class="mx-4 none-growth"
              :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
              :disabled="readOnly"
              :data-vv-as="' '"
              data-vv-name="roomsAmount"
            />
          </v-layout>
          <v-checkbox
            v-if="getPossessionsQuestions.living_conditions.hasOwnProperty('bath')"
            v-model="livingConditions.bath"
            v-validate="{ required: getPossessionsQuestions.living_conditions.bath.required }"
            :label="getPossessionsQuestions.living_conditions.bath.label"
            type="checkbox"
            off-icon=""
            on-icon="check"
            class="none-growth mr-4 mt-0 pt-0"
            :disabled="readOnly"
            :data-vv-as="' '"
            data-vv-name="bath"
          />
          <v-checkbox
            v-if="getPossessionsQuestions.living_conditions.hasOwnProperty('kitchen')"
            v-model="livingConditions.kitchen"
            v-validate="{ required: getPossessionsQuestions.living_conditions.kitchen.required }"
            :label="getPossessionsQuestions.living_conditions.kitchen.label"
            type="checkbox"
            off-icon=""
            on-icon="check"
            class="none-growth mt-0 pt-0"
            :disabled="readOnly"
            :data-vv-as="' '"
            data-vv-name="kitchen"
          />
        </v-layout>
      </li>
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('energy_exclusion')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getPossessionsQuestions.energy_exclusion.required }"
        >
          {{ getPossessionsQuestions.energy_exclusion.label }}
        </p>
        <v-checkbox
          v-for="(res, index) in resource2"
          :key="index"
          v-model="energyExclusion"
          v-validate="{ required: getPossessionsQuestions.energy_exclusion.required }"
          :label="res.description"
          :value="res.id"
          type="checkbox"
          off-icon=""
          on-icon="check"
          :disabled="isDisabled(energyExclusion, res.id, 314) || readOnly"
          :error="errors.has('energyExclusion')"
          :error-messages="
            index + 1 === resource2.length ? errors.collect('energyExclusion') : null
          "
          :data-vv-as="$t('label.question')"
          :data-vv-name="'energyExclusion'"
        />
      </li>
      <SheetQuestion
        v-if="getPossessionsQuestions.hasOwnProperty('can_afford_heating_the_house')"
        :label="getPossessionsQuestions.can_afford_heating_the_house.label"
        :required="getPossessionsQuestions.can_afford_heating_the_house.required"
      >
        <ConfirmButtons
          v-model="canAffordHeatingTheHouse"
          v-validate="{ required: getPossessionsQuestions.can_afford_heating_the_house.required }"
          string
          :error-messages="errors.collect('canAffordHeatingTheHouse')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'canAffordHeatingTheHouse'"
          :disabled="readOnly"
        />
      </SheetQuestion>
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('has_farm')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getPossessionsQuestions.has_farm.required }"
        >
          {{ getPossessionsQuestions.has_farm.label }}
        </p>
        <ConfirmButtons
          v-model="hasFarm"
          v-validate="{ required: getPossessionsQuestions.has_farm.required }"
          string
          :error-messages="errors.collect('hasFarm')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'hasFarm'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('has_vehicle')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getPossessionsQuestions.has_vehicle.required }"
        >
          {{ getPossessionsQuestions.has_vehicle.label }}
        </p>
        <ConfirmButtons
          v-model="hasVehicle"
          v-validate="{ required: getPossessionsQuestions.has_vehicle.required }"
          string
          :error-messages="errors.collect('hasVehicle')"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'hasVehicle'"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('connection')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getPossessionsQuestions.connection.required }"
        >
          {{ getPossessionsQuestions.connection.label }}
        </p>
        <v-checkbox
          v-for="(res, index) in resource5"
          :key="index"
          v-model="connection"
          v-validate="{ required: getPossessionsQuestions.connection.required }"
          class="d-flex append_flexed"
          :label="res.description"
          :value="res.id"
          type="checkbox"
          off-icon=""
          on-icon="check"
          :disabled="isDisabled(connection, res.id, 315) || readOnly"
          :error="errors.has('connection')"
          :error-messages="index + 1 === resource5.length ? errors.collect('connection') : null"
          :data-vv-as="$t('label.question')"
          :data-vv-name="'connection'"
        />
      </li>
      <li
        v-if="connection.includes(47) && getPossessionsQuestions.hasOwnProperty('internet_usage')"
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getPossessionsQuestions.internet_usage.required }"
        >
          {{ getPossessionsQuestions.internet_usage.label }}
        </p>
        <v-textarea
          v-model="internetUsage"
          v-validate="{ ...requiredRegularField(getPossessionsQuestions.internet_usage.required) }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('required_regular_field_12')"
          :data-vv-as="$t('label.question')"
          data-vv-name="required_regular_field_12"
          :required="getPossessionsQuestions.internet_usage.required"
          class="small"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="getPossessionsQuestions.hasOwnProperty('remote_education')"
        class="mt-4"
      >
        <p
          class="header"
          :class="{ required: getPossessionsQuestions.remote_education.required }"
        >
          {{ getPossessionsQuestions.remote_education.label }}
          <span
            v-if="!getPossessionsQuestions.remote_education.required"
            class="optional-text"
          >{{
            $t('message.optional') | brackets
          }}</span>
        </p>
        <ConfirmButtons
          v-model="remoteEducation"
          v-validate="{ required: getPossessionsQuestions.remote_education.required }"
          string
          :error-messages="errors.collect('remoteEducation')"
          data-vv-as=" "
          :disabled="readOnly"
          :data-vv-name="'remoteEducation'"
        />
      </li>
      <li
        v-if="
          remoteEducation === 'no' &&
            getPossessionsQuestions.hasOwnProperty('remote_education_barriers')
        "
        class="mt-4"
      >
        <p
          class="header custom lA"
          :class="{ required: getPossessionsQuestions.remote_education_barriers.required }"
        >
          {{ getPossessionsQuestions.remote_education_barriers.label }}
        </p>
        <v-checkbox
          v-for="(res, index) in remoteEducationBarriersResources"
          :key="index"
          v-model="remoteEducationBarriers"
          v-validate="{ required: getPossessionsQuestions.remote_education_barriers.required }"
          multiple
          :label="res.description"
          :value="res.id"
          type="checkbox"
          :error="errors.has('remoteEducationBarriers')"
          :error-messages="
            index + 1 === remoteEducationBarriersResources.length
              ? errors.collect('remoteEducationBarriers')
              : null
          "
          data-vv-as=" "
          :data-vv-name="'remoteEducationBarriers'"
        />
      </li>
      <li
        v-if="
          remoteEducationBarriers != null &&
            remoteEducationBarriers.includes(351) &&
            getPossessionsQuestions.hasOwnProperty('remote_education_barriers')
        "
        class="mt-4"
      >
        <p :class="{ required: getPossessionsQuestions.other_remote_education_barriers.required }">
          {{ getPossessionsQuestions.other_remote_education_barriers.label }}
        </p>
        <v-textarea
          v-model="otherRemoteEducationBarriers"
          v-validate="{
            ...requiredRegularField(
              getPossessionsQuestions.other_remote_education_barriers.required
            )
          }"
          :placeholder="$t('placeholders.add_text')"
          :error-messages="errors.collect('otherRemoteEducationBarriers')"
          data-vv-as=" "
          data-vv-name="otherRemoteEducationBarriers"
          :required="getPossessionsQuestions.other_remote_education_barriers.required"
          class="small"
          :disabled="readOnly"
        />
      </li>
      <li
        v-if="
          remoteEducation === 'no' &&
            getPossessionsQuestions.hasOwnProperty('remote_education_number_of_excluded_children')
        "
        class="mt-4"
      >
        <p
          class="header custom lB"
          :class="{
            required: getPossessionsQuestions.remote_education_number_of_excluded_children.required
          }"
        >
          {{ getPossessionsQuestions.remote_education_number_of_excluded_children.label }}
        </p>
        <v-layout align-center>
          <span class="fw-600">{{
            getPossessionsQuestions.remote_education_number_of_excluded_children.sub_label
          }}</span>
          <CounterButtons
            v-model="remoteEducationNumberOfExcludedChildren"
            v-validate="{
              required:
                getPossessionsQuestions.remote_education_number_of_excluded_children.required
            }"
            class="ml-4 mt-0 none-growth"
            :class="[{ 'mb-2': $vuetify.breakpoint.xs }]"
            :disabled="readOnly"
            :data-vv-as="' '"
            :error-messages="errors.collect('remoteEducationNumberOfExcludedChildren')"
            data-vv-name="remoteEducationNumberOfExcludedChildren"
          />
        </v-layout>
      </li>
    </ol>
  </v-flex>
</template>

<script>
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
import CounterButtons from '@/components/widgets/sheet/CounterButtons';
import livingConditionTypeResource from '@/mixins/livingConditionTypeResource';

import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';
import filters from '@/constants/filters';

import { mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import SheetQuestion from '../../SheetQuestion.vue';

const { mapFields } = createHelpers({
    getterType: 'sheet/getPossessionsField',
    mutationType: 'sheet/updatePossessionsField'
});

export default {
    name: 'QuestionsPossessions',
    components: {
        ConfirmButtons,
        CounterButtons,
        SheetQuestion
    },
    inject: ['$validator'],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        ...mapFields([
            'livingConditions',
            'energyExclusion',
            'hasFarm',
            'hasVehicle',
            'connection',
            'internetUsage',
            'computerOrTabletNumber',
            'remoteEducation',
            'remoteEducationBarriers',
            'otherRemoteEducationBarriers',
            'remoteEducationNumberOfExcludedChildren',
            'canAffordHeatingTheHouse'
        ]),
        ...mapGetters('sheet', ['getPossessionsQuestions']),
        resource2 () {
            return this.getResources(this.getPossessionsQuestions.energy_exclusion);
        },
        resource5 () {
            return this.getResources(this.getPossessionsQuestions.connection);
        },
        remoteEducationBarriersResources () {
            return this.getResources(this.getPossessionsQuestions.remote_education_barriers);
        }
    },
    filters: { ...filters },
    mixins: [sheetValidationRules, livingConditionTypeResource, sheetResourcesGetter],
    watch: {
        connection (val) {
            if (!val.includes(47)) {
                this.internetUsage = null;
            }
            if (!val.includes(46)) {
                this.computerOrTabletNumber = null;
            }
        },
        remoteEducation: {
            handler (val) {
                if (val !== 'no') {
                    this.remoteEducationNumberOfExcludedChildren = null;
                    this.remoteEducationBarriers = null;
                }
            },
            immediate: true
        },
        remoteEducationBarriers: {
            handler (val) {
                if (!val || !val.includes(351)) {
                    this.otherRemoteEducationBarriers = null;
                }
            }
        }
    },
    methods: {
        isDisabled (model, id, excludeId) {
            if (model.includes(excludeId)) {
                if (model.includes(id) && id !== excludeId) {
                    model.splice(model.indexOf(id), 1);
                }
                return id !== excludeId;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
